// eslint-disable-next-line import/prefer-default-export
export function getHotelId(url) {
  // eslint-disable-next-line no-useless-escape
  const result = /hotel\/([^\/]+)/gi.exec(url);
  return result == null ? null : result[1];
}



// WEBPACK FOOTER //
// ./src/lib/util/util.js